// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import ChecklistItemController from "./checklist_item_controller.js"
application.register("checklist-item", ChecklistItemController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import DragController from "./drag_controller.js"
application.register("drag", DragController)

import EmptyStateController from "./empty_state_controller.js"
application.register("empty-state", EmptyStateController)

import FetchTitleController from "./fetch_title_controller.js"
application.register("fetch-title", FetchTitleController)

import GoalsFilterController from "./goals_filter_controller.js"
application.register("goals-filter", GoalsFilterController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import MeetingController from "./meeting_controller.js"
application.register("meeting", MeetingController)

import MeetingItemController from "./meeting_item_controller.js"
application.register("meeting-item", MeetingItemController)

import MeetingTemplateController from "./meeting_template_controller.js"
application.register("meeting-template", MeetingTemplateController)

import MentionsController from "./mentions_controller.js"
application.register("mentions", MentionsController)

import NotificationController from "./notification_controller.js"
application.register("notification", NotificationController)

import PermissableController from "./permissable_controller.js"
application.register("permissable", PermissableController)

import SmartController from "./smart_controller.js"
application.register("smart", SmartController)

import ServiceWorkerController from "./service_worker_controller.js"
application.register("service-worker", ServiceWorkerController)

import TableController from "./table_controller.js"
application.register("table", TableController)

import ChoicesController from "./choices_controller.js"
application.register("choices", ChoicesController)

import FilterController from "./filter_controller.js"
application.register("filter", FilterController)

import ScrollController from "./scroll_controller.js"
application.register("scroll", ScrollController)